import { render, staticRenderFns } from "./quesPlay7.vue?vue&type=template&id=4c659be4"
import script from "./quesPlay7.vue?vue&type=script&lang=js"
export * from "./quesPlay7.vue?vue&type=script&lang=js"
import style0 from "./quesPlay7.vue?vue&type=style&index=0&id=4c659be4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports